const JUDGEME_TRIGGER_SELECTORS = ['.jdgm-prev-badge', '.jdgm-star', '.jm-star-rating', '.jm-review-card__rating'];
const JUDGEME_TARGET_SELECTORS = ['#judgeme_product_reviews', '.jdgm-widget.jdgm-review-widget', '.jm-review-widget', '.jdgm-cards-carousel'];

const getReviewTarget = () => {
  for (const selector of JUDGEME_TARGET_SELECTORS) {
    const node = document.querySelector(selector);
    if (node) return node;
  }

  return null;
};

const hasReviewTrigger = (element) => {
  if (!(element instanceof Element)) return false;
  return JUDGEME_TRIGGER_SELECTORS.some((selector) => element.closest(selector));
};

document.addEventListener(
  'click',
  (event) => {
    if (!hasReviewTrigger(event.target)) return;

    const reviews = getReviewTarget();
    if (!reviews) return;

    event.preventDefault();

    const scrollTop = Math.max(0, reviews.getBoundingClientRect().top + window.scrollY - 100);
    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  },
  { passive: false }
);
